import { render } from "./InsuredInfo.vue?vue&type=template&id=822c39ee&scoped=true"
import script from "./InsuredInfo.vue?vue&type=script&lang=js"
export * from "./InsuredInfo.vue?vue&type=script&lang=js"

import "./InsuredInfo.vue?vue&type=style&index=0&id=822c39ee&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Rufiz Huseynzada\\OneDrive - Azerbaijan State Oil and Industry University\\Desktop\\ProgressProjects\\Account\\web\\Medical-Account-Web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-822c39ee"]])

export default __exports__